/// <amd-module name="Build/Admin/AgentCloudsList/Stores/StoresHub" />
import { ActionsHub } from "Build/Admin/AgentCloudsList/Actions/ActionsHub";
import { AgentCloudStore } from "Build/Admin/Common/Stores/AgentCloudStore";
import { NotificationStore } from "Build/Admin/Common/Stores/NotificationStore";

export class StoresHub {
    public agentCloudStore: AgentCloudStore;
    public notificationStore: NotificationStore;

    constructor(actionsHub: ActionsHub) {
        this.agentCloudStore = new AgentCloudStore();
        actionsHub.agentCloudActions.agentCloudsUpdated.addListener(this.agentCloudStore.updateAgentClouds);
        actionsHub.agentCloudActions.agentCloudAdded.addListener(this.agentCloudStore.addOrUpdateAgentCloud);
        actionsHub.agentCloudActions.agentCloudDeleted.addListener(this.agentCloudStore.deleteAgentCloud);

        this.notificationStore = new NotificationStore();
        actionsHub.notificationActions.addNotification.addListener(this.notificationStore.addNotification);
        actionsHub.notificationActions.dismissNotification.addListener(this.notificationStore.dismissNotification);
        actionsHub.notificationActions.clearNotifications.addListener(this.notificationStore.clearNotifications);

    }
}
